module.exports = __webpack_public_path__ + "img/rank_right.eb3cda66.svg";